export const CREATE_MISC_CONTRACT = "CREATE_MISC_CONTRACT";
export const FETCH_MISC_CONTRACTS = "FETCH_MISC_CONTRACTS";
export const FETCH_MISC_CONTRACT = "FETCH_MISC_CONTRACT";
export const EDIT_MISC_CONTRACT = "EDIT_MISC_CONTRACT";
export const DELETE_MISC_CONTRACT = "DELETE_MISC_CONTRACT";
